const isDecimalEqualsZero = (amount: number) => {
  return parseFloat(amount.toString().slice(-2)) === 0;
};

const getToUSDFormatter = (amount: number, hideFractionDigits = false) => {
  const decimalCount =
    hideFractionDigits && isDecimalEqualsZero(amount) ? 0 : undefined;

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: decimalCount,
  });
};

export const centsToUSD = (amount: number, hideFractionDigits?: boolean) =>
  getToUSDFormatter(amount || 0, hideFractionDigits).format(
    (amount || 0) / 100
  );

export const getDiscountedAmount = (
  amount: number,
  discountPercentage = 0,
  discountAmount = 0
) => (amount * (100 - discountPercentage)) / 100 - discountAmount;

export const isEven = (n: number) => Math.abs(n % 2) === 0;

export const isLastOfArray = (index: number, length: number) =>
  index === length - 1;

export const format2Decimals = (amount: number) =>
  Number(amount / 100).toFixed(2);

export const extractDecimalNumber = (currencyString: string) => {
  const pattern = /\$\d+(\.\d+)?/;
  const matches = currencyString.match(pattern);
  if (matches && matches.length > 0) {
    return parseFloat(matches[0].replace("$", ""));
  }
  return null;
};
